import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { Text } from "@react-pdf/renderer";
import { PDFTitle } from "../../export-pdf/components/title";

export const PDFPlatformIncluded = ({
  platformDisplayed,
}: {
  platformDisplayed: string;
}) => {
  const { typographyStyle } = useAnalysisPDFStyles();

  return (
    <>
      <PDFTitle title="Platforms included in the analysis" />
      <Text
        style={{
          ...typographyStyle?.body1,
        }}
      >
        { platformDisplayed }
      </Text>
    </>
  );
};